import {
  SENDCVVBYSMS_SUCCESS,
  SENDCVVBYSMS_FAILED,
  SENDCVVBYSMS_INVALID_REQUEST,
  LOADING_SENDCVVBYSMS,
  SENDCVVBYSMS_NOTFOUND,
  RESET_SENDCVVBYSMS
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_SENDCVVBYSMS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case SENDCVVBYSMS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case SENDCVVBYSMS_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDCVVBYSMS_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case SENDCVVBYSMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_SENDCVVBYSMS:
      return (state = initialState);

    default:
      return state;
  }
};
